import { ConsolePage } from './pages/ConsolePage';
import './App.scss';
import Property from './tools';

function App() {
  return (
    <div data-component="App">
      <ConsolePage />
      {/* <Property /> */}
    </div>
  );
}

export default App;
